// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__W4xAP","left":"styles_left__3HzVk"};